import React from 'react';
import { AonDialog } from '../../components/core/AonDialog';
import { AonButton } from '../../components/core/AonButton';
import { BUTTON_VARIANT } from '../../components/core/AonButton/consts';
import { UuiLogo } from '@aonunited/react';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import "./AMBestDialog.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var AMBestDialog = function (props) {
    var textContent = {
        Stable: "Stable financial and market trends, low likelihood the rating will change over the next 12-36 months.",
        Negative: "Unfavorable financial and market trends - If trends continue, good possibility of rating downgrade over the next 12-36 months.",
        Positive: "Favorable financial and market trends - If trends continue, good possibility of rating upgrade over the next 12-36 months.",
        Developing: "Rating under review and may change in the near term, usually due to recent event(s) "
    };
    var Footer = function () {
        return React.createElement("div", null,
            React.createElement(AonButton, { style: { marginInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: props.onClickClose }, "Close"));
    };
    var Body = function () {
        return React.createElement("div", { className: 'ambest-body' },
            React.createElement("h3", null, "AM Best Outlook Definitions"),
            React.createElement("div", { className: 'AMBest-text-container' }, Object.keys(textContent).map(function (label) { return (React.createElement("div", { className: 'AMBest-text-wrapper' },
                React.createElement("span", { className: 'label' },
                    label,
                    ":"),
                React.createElement("div", { className: 'text' }, textContent[label]))); })));
    };
    return (React.createElement(AonDialog, { dismissOnEsc: false, dismissOnOverlay: false, opened: props.showDialog, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
            React.createElement("div", { className: 'logo_about_dialog' },
                React.createElement(UuiLogo, { onClick: function () { } })),
            React.createElement(FontAwesomeIcon, { className: 'text-icon', onClick: props.onClickClose, icon: faClose })), body: React.createElement(Body, null), footer: React.createElement(Footer, null) }));
};
export default AMBestDialog;
